import { useRef, useState } from 'react';
import IntersectionObserverElement from '@/components/IntersectionObserverElement/IntersectionObserverElement';
import EmailSignupField from '@/components/HomePageV2/EmailSignupField/EmailSignupField';
import HeroVideoPoster from 'public/assets/summer-slide/HeroVideoPosterAcute.jpg';
import VimeoPlayer from '@/components/SummerSlide/VimeoPlayer/VimeoPlayer';

export default function HeroVideoPlayer({ setRedirectModal, setInactiveAccount }) {
    const [sectionVisible, setSectionVisible] = useState(false);
    const elementRef = useRef(null);

    return (
        <section className='py-16 pt-32 md:py-24 text-center md:text-left px-4 md:px-8 relative z-[2] overflow-hidden ] text-white'>
            <IntersectionObserverElement updateElementIsVisible={setSectionVisible} classNames='' ref={elementRef} />
            <div className='hidden md:block absolute top-[50px] right-0 rounded-full opacity-[0.7] bg-[#B031FA] bg-opacity-[0.5] blur-[250px] w-[729px] h-[585px] z-[1]' />
            <div className='hidden md:block absolute bottom-[50px] left-0 rounded-full opacity-[0.7] bg-[#161042] bg-opacity-[0.5] blur-[250px] w-[729px] h-[585px] z-[1]' />
            <div className='container mx-auto z-[2] relative md:flex md:flex-row md:items-center md:gap-8  max-w-[1500px'>
                <div className='md:flex-1'>
                    <h1 className='font-normal text-white text-[42px] sm:text-[69px] xl:text-[76px] my-0 mb-6 text-center md:text-left leading-[3rem] md:leading-[4rem]'>
                        Math like <br />
                        <span className='text-[#64DFE5] font-Gloria leading-6 sm:leading-[100px] md:leading-[4.5rem]'>never before</span>
                    </h1>
                    <div className='md:flex-1 ghost-inspector-hide mt-5 sm:mt-10 md:mt-0 max-w-[1000px] mx-auto md:mx-0 block md:hidden'>
                        <VimeoPlayer
                            videoId='1139404130'
                            posterImage={HeroVideoPoster}
                            isVisible={sectionVisible}
                            className='w-full rounded-lg shadow-lg'
                            autoplay={true}
                            muted={true}
                            loop={false}
                            controls={true}
                            aspectRatio='16:9'
                            pauseWhenHidden={true}
                            resumeWhenVisible={true}
                        />
                    </div>
                    <p className='text-lg md:text-xl lg:text-xl mb-8 mx-auto md:mx-0 opacity-90 max-w-[600px]'>
                        Give your child the gift of fun, music-powered math learning. Muzology makes mastering math concepts engaging and memorable for grades 3-8.
                    </p>
                    <div className='mt-8'>
                        <EmailSignupField
                            className='flex flex-col md:flex-row justify-center md:justify-start items-center gap-4'
                            inputClassName='text-[18px] w-full max-w-[260px] md:max-w-[280px] xl:max-w-[300px] pl-0 md:pl-4 py-[26px] border-[1px] border-solid border-white text-white font-normal rounded-full text-center md:text-left'
                            setRedirectModal={setRedirectModal}
                            setInactiveAccount={setInactiveAccount}
                        />
                    </div>
                </div>
                <div className='md:flex-1 ghost-inspector-hide mt-5 sm:mt-10 md:mt-0 max-w-[1000px] mx-auto md:mx-0 hidden md:block'>
                    <VimeoPlayer
                        videoId='1139404130'
                        posterImage={HeroVideoPoster}
                        isVisible={sectionVisible}
                        className='w-full rounded-lg shadow-lg'
                        autoplay={true}
                        muted={true}
                        loop={false}
                        controls={true}
                        aspectRatio='16:9'
                        pauseWhenHidden={true}
                        resumeWhenVisible={true}
                    />
                </div>
            </div>
        </section>
    );
}
